import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbDateParserFormatter, NgbActiveModal, NgbModal, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import moment from 'moment';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ExpenseTripFormComponent } from '../expense-trip-form/expense-trip-form.component';

@Component({
  selector: 'app-advance-expense-form',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, NgbDatepickerModule, NgbDropdownModule, NgSelectModule,],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './advance-expense-form.component.html',
  styleUrl: './advance-expense-form.component.scss'
})
export class AdvanceExpenseFormComponent {
  isDisabled: boolean = false;
  Trips = [] as any;
  Data = {
    SelectType: 'INSERT',
    ESS_ExpenseAdvanceRequestId: null,
    EmpMasterId: null,
    TripId: null,
    AdvanceAmount: null as any,
    FromDate: null as any,
    ToDate: null as any,
    Description: null as any,
  }

  constructor(
    private activeModal: NgbActiveModal,
    private expense: ExpenseService,
    private modalService: NgbModal,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    private toast: ToastService,
    protected common: CommonService,
    private session: SessionService,
  ) { 
    this.Data.EmpMasterId = this.session.GetUserDetails().UserId;
  }

  ngOnInit(): void {
    this.ESS_TripMaster_SelectUpdate();
  }

  Verification(form: any) {
    if (form.valid) {
      if (this.Data.AdvanceAmount > 0) {
        this.ESS_ExpenseAdvanceRequest_InsertUpdate();
      } else {
        this.toast.show({ message: 'Advance amount must be greater than 0', type: toastTypeEnum.danger });
      }
    }
    else {
      form.submitted = true;
    }
  }

  ESS_ExpenseAdvanceRequest_InsertUpdate() {
    this.isDisabled = true;
    this.expense.ESS_ExpenseAdvanceRequest_InsertUpdate(this.Data).subscribe({
      next: (response) => {
        if (response.Error_Code == "467") {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.activeModal.close(true);
            }
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_TripMaster_SelectUpdate() {
    this.isDisabled = true;
    this.expense.ESS_TripMaster_SelectUpdate({ SelectType: 'S', ESS_TripMasterID: 0,EmpMasterId : this.session.GetUserDetails().UserId }).subscribe({
      next: (response) => {
        this.Trips = response.Table.filter((e:any) => e.IsSendForApproval == 0);
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  getTripDate() {
    if (this.Data.TripId != null && this.Data.TripId > 0) {
      if (this.Trips.filter((e: any) => e.ESS_TripMasterID == this.Data.TripId)[0].FromDate != null && this.Trips.filter((e: any) => e.ESS_TripMasterID == this.Data.TripId)[0].FromDate != '') {
        this.Data.FromDate = this.dateFormat.parse(this.Trips.filter((e: any) => e.ESS_TripMasterID == this.Data.TripId)[0].FromDate);
      } else {
        this.Data.FromDate = null;
      }

      if (this.Trips.filter((e: any) => e.ESS_TripMasterID == this.Data.TripId)[0].ToDate != null && this.Trips.filter((e: any) => e.ESS_TripMasterID == this.Data.TripId)[0].ToDate != '') {
        this.Data.ToDate = this.dateFormat.parse(this.Trips.filter((e: any) => e.ESS_TripMasterID == this.Data.TripId)[0].ToDate);
      } else {
        this.Data.ToDate = null;
      }
      this.Data.Description = this.Trips.filter((e: any) => e.ESS_TripMasterID == this.Data.TripId)[0].Description;
    }
  }

  addTrip() {
    const modalRef = this.modalService.open(ExpenseTripFormComponent, { backdrop: 'static', });
    modalRef.result.then(
      (result: any) => { 
        if(result != undefined && result){
          this.ESS_TripMaster_SelectUpdate();
        }
      },
      () => { }
    );
  }
  
  close() {
    this.activeModal.close();
  }
}
